import { useNavigate, useSearchParams } from 'react-router-dom';

import { AuthPageLayout,ResetPasswordForm } from '@ekhodealer/ekho-common/auth-client';

import { paths } from '@config/paths';

/**
 * Reset Password page - reads oobCode from URL and passes to form
 */
export default function ResetPasswordPage() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const oobCode = searchParams.get('oobCode');

	return (
		<AuthPageLayout>
			<ResetPasswordForm
				oobCode={oobCode}
				onSuccess={() => navigate(paths.login.getHref())}
				onBackToLogin={() => navigate(paths.login.getHref())}
				onRequestNewLink={() => navigate(paths.forgotPassword.getHref())}
			/>
		</AuthPageLayout>
	);
}
